export const SCREENSHOT_SIZES = {
    width: 1200,
    height: 630,
    x: 0,
    y: 0
};
